module.exports = __webpack_public_path__ + "img/bg1@2x.ec0f7a03.png";